/**
CREATIVE CODING
---
Kill server : CTRL + C
Start server : npm run start
Final build : npm run build
Final build for axl : npm run axl
---
**/

import AxL from "./axl";
import ShockwaveImage from "./ShockwaveImage";
// import * as Papa from "papaparse";
import UI from "./UI";
import Loader from "./Loader";
import BubbleLoader from "./BubbleLoader";
import InteractiveImage from "./InteractiveImage";
import ColorData from "./ColorData";
import Utils from "./Utils";
import Bubbles from "./Bubbles";
import AssetInfoBox from "./AssetInfoBox";
import Hint from "./Hint";
import Intro from "./Intro";
import ShareScreen from "./ShareScreen";
import AboutBox from "./AboutBox";
import ServerMessageBox from "./ServerMessageBox";
import ShareManager from "./ShareManager";
import Network from "./Network";
import NetworkMessageBox from "./NetworkMessageBox";
import FBConnection from "./FBConnection";
import Tracking from "./Tracking";

const IMAGE_TIMEOUT = 12000; // change this when testing locally
const BUBBLE_TIMEOUT = 10000; // change this when testing locally
const IS_USING_FIREBASE_WORKER = true;
export default class App {
  constructor() {
    console.log(
      "%c ✨ CANVAS EXPERIMENT ✨ ",
      "background: #000; color: #f0f; padding:10px;"
    );
    this.COLOR_RECORDER_FOR_INTRO = [];
    this.handler = {
      down: this.onkeydown.bind(this),
      message: this.onWorkerMessage.bind(this),
      imageready: this.onImageReady.bind(this),
      newdataloaded: this.onNewDataLoaded.bind(this),
      uichange: this.onUIChange.bind(this),
      textureupdated: this.textureupdated.bind(this),
      hascolored: this.onAddedColor.bind(this),
      hasdrawnmagic: this.onHasDrawnMagic.bind(this),
      hasdrawnpen: this.onHasDrawnPen.bind(this),
      bubbleClick: this.bubbleClick.bind(this),
      resize: this.onResize.bind(this),
      bubbleAppear: this.bubbleAppear.bind(this),
      visitAsset: this.visitAsset.bind(this),
      visitLink: this.visitLink.bind(this),
      introEnded: this.onIntroEnded.bind(this),
      network: this.onNetworkChange.bind(this),
      suggestHint: this.onSuggestHint.bind(this),
      showTryHint: this.onShowTryHint.bind(this),
      skipIntro: this.onSkipIntro.bind(this),
    };

    // network check
    this.network = new Network();
    this.network.addEventListener("change", this.handler.network);
    this.network.addEventListener("change", this.handler.network);
    //FIREBASE
    this.FBListener = new FBConnection();
    this.FBListener.addEventListener("message", this.handler.message);

    console.log("workers...");
    // WORKERS
    // this.ImageLoaderWorker = new Worker(
    //   new URL("./workers/image-loader.worker.js", import.meta.url),
    //   {
    //     type: "module",
    //   }
    // );
    // this.ImageLoaderWorker.addEventListener("message", this.handler.message);
    this.initImageWorker();
    console.log("ImageLoaderWorker...");

    // this.imageFeaturesWorker = new Worker(
    //   new URL("./workers/image-features.worker.js", import.meta.url),
    //   {
    //     type: "module",
    //   }
    // );
    // this.imageFeaturesWorker.addEventListener("message", this.handler.message);
    this.initFeaturesWorker();
    console.log("init data list...");

    // detect language
    // this.supportedLangs = ["en", "es-419", "es", "fr", "hi", "it", "ja", "pt-BR", "pt-PT", "zh-CN", "zh-TW"];
    this.supportedLangs = ["en", "fr", "ja", "es-419", "es"];
    this.language = this.getLanguage();
    this.loadFiles();
  }

  initImageWorker() {
    this.ImageLoaderWorker = new Worker(
      new URL("./workers/image-loader.worker.js", import.meta.url),
      {
        type: "module",
      }
    );
    this.ImageLoaderWorker.addEventListener("message", this.handler.message);
  }
  initFeaturesWorker() {
    this.imageFeaturesWorker = new Worker(
      new URL("./workers/image-features.worker.js", import.meta.url),
      {
        type: "module",
      }
    );
    this.imageFeaturesWorker.addEventListener("message", this.handler.message);
  }

  async loadFiles() {
    const data = await Utils.loadMultipleCSV([
      `${GLOBAL_PATH}csv/json_filtered.csv`,
      /*`${GLOBAL_PATH}csv/json_list.csv`,
      `${GLOBAL_PATH}csv/json_list2.csv`,*/
    ]);
    // load translations
    this.translations = await Utils.load(
      `${GLOBAL_PATH}json/translations/${this.language}.json`
    );
    this.dataIsReady(data);
  }

  dataIsReady(data) {
    this.data = data;
    console.log("data is ready");
    this.playIntro = true;
    this.tracker = null;
    this.axl = new AxL();
    this.initAxL();
    if (window._y010) this.initApp();
  }

  initAxL() {
    //------------
    const gotFirstResume = new Promise((resolve) => {
      this.axl.registerMessageCallback(AxL.HostToChild.RESUME, (payload) => {
        console.log("init RESUME ");
        resolve();
      });
    });

    const gameReady = this.axl.handshake().then(async (initialData) => {
      console.log("handshake is done", initialData);
      if (initialData.hasOwnProperty("imageID")) {
        // console.log("imageID Is set");
        this.SHARED_IMAGE_ID = initialData.imageID;

        console.log("imageID Is set", this.SHARED_IMAGE_ID);
      } else {
        console.log("imageID Is not set");
      }
      // let objJsonStr = JSON.stringify(initialData);
      // let objJsonB64 = Buffer.from(objJsonStr).toString("base64");
      // console.log(objJsonB64);
    });

    // Make sure game is initialized AND we got the first resume call
    Promise.all([gotFirstResume, gameReady]).then(() => {
      this.initTracking();
      this.initApp();
    });
  }

  getLanguage() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let lang = urlParams.get("lang");
    if (lang == null) lang = "en";
    let isLangSupported = this.supportedLangs.includes(lang);
    if (!isLangSupported) {
      lang = "en";
    }
    if (lang == "es") lang = "es-419";
    if (lang == "pt-PT") lang = "pt-BR";
    return lang;
  }

  initTracking() {
    console.log("initTracking");
    this.tracker = new Tracking(this.axl);
  }

  initApp() {
    console.log("initApp");
    this.introSequence = null;
    //
    this.sharing = new ShareManager(this.axl, this.tracker);
    this.sharing.translations = this.translations;
    // THE UI
    this.ui = new UI(
      document.getElementById("UI"),
      this.translations,
      this.tracker
    );
    this.deactivateInteraction();
    this.ui.addEventListener("change", this.handler.uichange);
    this.loader = new Loader(document.querySelector(".loader-container"));
    this.bubbleLoader = new BubbleLoader(
      document.querySelector(".bubble-loader")
    );

    // THE EXTRA UI
    this.colorizeBTN = document.querySelector(".button-wrapper");
    this.colorizeBTN.addEventListener(
      "click",
      this.delegateColorize.bind(this)
    );

    // Result screen button container
    this.endScreenButtonsContainer = document.querySelector(
      ".end-buttons-container"
    );
    // THE 'BACK TO EDIT' BUTTON
    this.backToEditBTN = document.querySelector("#back-to-edit");
    this.backToEditBTN.addEventListener(
      "click",
      this.backToEditScreen.bind(this)
    );

    // the share button (mobile layout)
    this.shareMobileLayoutBTN = document.querySelector("#share-mobile");
    this.shareMobileLayoutBTN.addEventListener("click", () => {
      this.shareImage(this.colorizedImage.b64_image);
    });

    // the download button (mobile layout)
    this.downloadBTN = document.querySelector("#download-mobile");
    this.downloadBTN.addEventListener("click", () => {
      this.downloadImage(this.colorizedImage.b64_image);
    });

    // THE DRAWING TOOL
    this.IMAGE = new InteractiveImage(
      document.querySelector("#imageSource"),
      this.data
    );
    // ACTIVATE THE OPTION TO AUTOMATE QUICKLY THE FULL DRAWING
    this.IMAGE.SUPER_HELPER = true;
    this.IMAGE.addEventListener("newdataloaded", this.handler.newdataloaded);
    this.IMAGE.addEventListener("imageready", this.handler.imageready);
    this.IMAGE.addEventListener("hasdrawnmagic", this.handler.hasdrawnmagic);
    this.IMAGE.addEventListener("hasdrawnpen", this.handler.hasdrawnpen);

    // THE COLORING TOOL
    const dimensions = { width: this.IMAGE.width, height: this.IMAGE.height };
    this.colorData = new ColorData(dimensions);
    this.colorData.addEventListener("hascolored", this.handler.hascolored);
    this.colorData.ui = this.ui;

    // THE RENDERING TOOL
    this.colorizedImage = new ShockwaveImage(
      `${GLOBAL_PATH}images/white.png`,
      document.getElementById("resultImage")
    );
    this.colorizedImage.addEventListener(
      "textureupdated",
      this.handler.textureupdated
    );
    this.colorizedImage.addEventListener("badclick", this.handler.suggestHint);

    // THE BUBBLES ASSET LIST
    this.bubbles = new Bubbles(
      document.querySelector("#bubbles"),
      this.translations
    );
    this.bubbles.addEventListener("click", this.handler.bubbleClick);
    this.bubbles.addEventListener("appear", this.handler.bubbleAppear);

    // The "more info" box
    this.assetInfoBox = new AssetInfoBox();
    this.assetInfoBox.addEventListener("visit_asset", this.handler.visitAsset);

    // The "about" box
    this.aboutBox = new AboutBox(document.querySelector(".about-screen"));
    this.aboutBox.addEventListener("visit_link", this.handler.visitLink);

    // The hints
    this.hint = new Hint(document.querySelector(".hint"), this.translations);

    // The server message box
    this.serverMessageBox = new ServerMessageBox(
      document.querySelector(".server-message-screen")
    );
    // The network message box
    this.networkMessageBox = new NetworkMessageBox(
      document.querySelector(".network-message-screen")
    );

    // The share screen
    this.shareScreen = new ShareScreen(
      document.querySelector(".share-screen"),
      this
    );

    // THE HIDDEN FUNCTIONALITY
    document.addEventListener("keydown", this.handler.down);

    // WINDOW SIZE HANDLER
    window.addEventListener("resize", this.handler.resize);

    // Show the loader
    this.loader.show();
  }

  onResize(e) {
    this.reset();
    // this.fullReset();
    this.organizeUI();
    this.killRunningProcesses();
  }

  onkeydown(e) {
    if (e.key == "Enter") {
      this.transformImage();
    }
    if (e.key == "t") {
      // console.log("t pushed");
      if (this.colorizedImage.imageUpdatedAtLeastOnce) {
        Utils.postImage(
          this.colorizedImage.view.toDataURL(),
          `${GLOBAL_PATH}connectedAssets`,
          this.imageFeaturesWorker
        );
      }
    }
    if (e.key == "c") {
      Utils.save(
        JSON.stringify(this.COLOR_RECORDER_FOR_INTRO),
        "colors.json",
        "application/json"
      );
    }
  }
  textureupdated(e) {
    if (this.colorizedImage.imageUpdatedAtLeastOnce) {
      // Utils.postImage(
      //   this.colorizedImage.view.toDataURL(),
      //   `${GLOBAL_PATH}connectedAssets`,
      //   this.imageFeaturesWorker
      // );

      // ----> !!! NEW FIREBASE LISTENER
      const param = {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({
          image: this.colorizedImage.view.toDataURL(),
          uid: this.FBListener.uid2,
        }),
      };
      Utils.postData(`${GLOBAL_PATH}connectedAssetsProcess`, param);
      console.log("///////// LAUNCH TIMEOUT");
      this.SAFETY_TIMEOUT = setTimeout(() => {
        console.log("THIS IS TAKING TOO LONG !!");
        this.serverMessageBox.show();
        this.killRunningProcesses();
      }, BUBBLE_TIMEOUT);
    }
  }
  onIntroEnded() {
    this.ui.showSwitch();
    if (this.introSequence) {
      this.introSequence.showAllTools();
      // this.introSequence = null;
    }

    // bypass the regular function to set hint
    // because after intro, is set to complete
    this.hint.state = "start_draw";
    // if (this.tracker) this.tracker.track("intro_complete");
    // if (this.axl) {
    //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "intro_complete",
    //     nonInteraction: true,
    //   });
    // }
  }

  onSkipIntro(data) {
    console.log("SKIP INTRO ! check the processes", this.introSequence);
    // this.killRunningProcesses();
    if (this.tracker) this.tracker.track("skip_intro");
  }

  onImageReady(data) {
    console.log("IMAGE READY");
    // OLD --------
    this.startTimer();
    this.colorizedImage.directChangeTexture(
      `${this.IMAGE.canvas.toDataURL("image/png")}`
    );
    //
    if (this.ui.switch.state) this.ui.force("magic");
    else this.ui.force("pen");
  }

  onSuggestHint(data) {
    console.log("show hint on the left drawing");
    this.hint.addArrow();
    this.hint.setArrowDown();
    this.hint.moveTo(this.colorData.color_image);
    this.hint.forceTranslate(this.colorData.color_image);
    this.hint.forceShow("sketch_panel");
    setTimeout(() => {
      this.hint.hide();
    }, 2000);
  }

  onShowTryHint() {
    const timeOut =
      Utils.isSmallOrMediumLayout() || Utils.isLandscapeMobile() ? 3500 : 0;
    window.setTimeout(() => {
      this.hint.addArrow();
      this.hint.setArrowLeft();
      this.hint.setHint("try_it_yourself");
      this.hint.moveTo(document.querySelector("li.magic"));
      this.hint.show();
    }, timeOut);
  }

  onNetworkChange(state) {
    if (state) {
      console.log("NETWORK ONLINE");
      this.networkMessageBox.hide();
      if (!this.ImageLoaderWorker) {
        this.initImageWorker();
        this.FBListener.initImageListener();
      }
      if (!this.imageFeaturesWorker) {
        this.initFeaturesWorker();
        this.FBListener.initJSONListener();
      }
    } else {
      console.log("NETWORK OFFLINE");
      this.networkMessageBox.show();
      // KILL RUNNING PROCESSES
      this.killRunningProcesses();
    }
  }
  killRunningProcesses() {
    // KILL RUNNING PROCESSES
    clearTimeout(this.SAFETY_TIMEOUT);
    // 1) ->SKIP INTRO
    if (this.introSequence) {
      this.introSequence.onMouseDown(null);
      this.introSequence = null;
    }
    // 2) ->COLORIZATION
    if (this.colorizedImage.isRunning) {
      this.colorizedImage.stop();
      this.colorizedImage.reset();
      // kill worker
      if (this.ImageLoaderWorker) {
        this.ImageLoaderWorker.terminate();
        this.ImageLoaderWorker = null;
      }
      // kill fbWorker
      this.FBListener.imageListener();
      this.FBListener.resume = false;
      console.log("LISTENER SHOULD BE KILLED");
      this.FBListener.initImageListener();
      // close panel
      this.organizeUI();
    }
    // 3) ->CONNECTED HARDWORK
    if (this.bubbleLoader.VISIBLE) {
      if (this.imageFeaturesWorker) {
        this.imageFeaturesWorker.terminate();
        this.imageFeaturesWorker = null;
      }
      this.bubbleLoader.hide();
      // kill fbWorker
      this.FBListener.jsonListener();
      this.FBListener.resume2 = false;
      this.FBListener.initJSONListener();
    }
  }

  async initColor() {
    // Force image resize to 512 x 512 pixels
    // because it might be smaller on mobile

    const resizedImage = Utils.imageToDataUri(this.IMAGE.canvas, 512, 512);
    const resizedColor = Utils.imageToDataUri(this.colorData.data, 512, 512);
    const resizedPosition = Utils.imageToDataUri(
      this.colorData.position_image,
      512,
      512
    );
    const newUID = this.FBListener.uid;
    // console.log("FIREBASE UID:", newUID);

    const param = {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify({
        image: resizedImage,
        color: resizedColor,
        position: resizedPosition,
        uid: newUID,
      }),
    };

    // this.ImageLoaderWorker.postMessage({
    //   url: `${GLOBAL_PATH}getColorImage`,
    //   param: param,
    // });

    this.colorizedImage.loadingState = true;
    // ------> !!!!! NEW SEND TO NEW PATH FOR THREADING + FIREBASE

    const result = await Utils.postData(
      `${GLOBAL_PATH}getColorImageProcess`,
      param
    );
    this.SAFETY_TIMEOUT = setTimeout(() => {
      console.log("THIS IS TAKING TOO LONG !!");
      this.serverMessageBox.show();
      this.colorizeBTN.classList.remove("deactivated");
      this.killRunningProcesses();
    }, IMAGE_TIMEOUT);

    //
    // if (this.axl && !this.introSequence) {
    //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "image_send_to_colorization",
    //     nonInteraction: true,
    //   });
    // }
  }

  onWorkerMessage(event) {
    console.log("MESSAGE FROM WORKER", event);
    if (event.data.base64) {
      clearTimeout(this.SAFETY_TIMEOUT);
      // enable the share button and download
      this.ui.showElement(document.querySelector("li.share"));
      //make sure it wiggles each time!
      document.querySelector("li.share").classList.remove("rubberBand");
      document.querySelector("li.share").classList.add("rubberBand");

      if (
        (this.axl &&
          AxL.can["download"] &&
          !navigator.userAgent.match("CriOS")) ||
        !this.axl
      ) {
        this.ui.showElement(document.querySelector("li.download"));
        this.ui.showElement(document.querySelector("button.download"));
      }
      this.stopTimer();
      this.colorizeBTN.classList.remove("deactivated");
      const imageData = event.data;
      this.colorizedImage.changeTexture(
        `data:image/png;base64,${imageData.base64}`
      );
      this.bubbleLoader.show();
      this.showResultScreen();
      if (Utils.isSmallOrMediumLayout() || Utils.isLandscapeMobile()) {
        if (this.introSequence) this.introSequence.introHints.setOpacity(0);
      }
      //
      // if (this.axl && !this.introSequence) {
      //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
      //     action: "colorized_image_received",
      //     nonInteraction: true,
      //   });
      // }
    }
    if (event.data.json) {
      clearTimeout(this.SAFETY_TIMEOUT);
      // console.log(event.data.json);
      this.bubbles.update(event.data.json);
    }
  }
  onUIChange(e) {
    this.state = e;
    // if (
    //   this.introSequence &&
    //   !this.ui.container.classList.contains("deactivate")
    // ) {
    //   console.log("UI CHANGE !!!");
    //   // this.introSequence.introHints.hintReset();
    //   // this.introSequence = null;
    // }
    console.log(
      "**** INTRO SEQUENCE FOR TRACKING ****",
      this.introSequence,
      this.INTRO_HAS_BEEN_INITIATED
    );
    // if (this.axl && !this.introSequence && this.INTRO_HAS_BEEN_INITIATED) {
    //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "toogle_ui_tools",
    //     label: this.state,
    //     value: 0,
    //     nonInteraction: false,
    //   });
    // }
    this.ui.activateElement("eraser");
    switch (e) {
      case "color":
        this.IMAGE.state = "color";
        if (this.colorizedImage.imageUpdatedAtLeastOnce) {
          document.getElementById("wrapper").classList.add("open");
          document
            .querySelector(".drawing-content .button-wrapper")
            .classList.add("open");
        }
        // SHOW THE DOT VIEW OVER THE IMAGE
        document.getElementById("colorSource").classList.remove("hide");
        // hide the hints
        this.hint.hide();
        this.hint.moveTo(this.colorizeBTN);
        this.hint.setHint("colorize");
        this.ui.deactivateElement("eraser");
        break;
      case "clear":
        this.closePanel();
        this.IMAGE.reset();
        this.colorData.clear();
        this.colorizedImage.reset();
        this.bubbles.reset();
        setTimeout(() => {
          this.ui.force("magic");
        }, 500);
        this.colorizeBTN.classList.remove("deactivated");
        this.colorizeBTN.classList.add("hidden");

        break;
      case "eraser":
        const eraserBTN = document.querySelector(".eraser");
        if (!eraserBTN.classList.contains("deactivated"))
          this.IMAGE.state = "eraser";
        break;
      case "refresh":
        if (this.network.ONLINE) {
          this.closePanel();
          this.IMAGE.reset(true);
          this.colorData.clear();
          this.colorizedImage.reset();
          this.hint.hide();
          this.hint.setHint("start_draw");
          this.hint.addArrow();
          this.hint.setArrowLeft();
          this.bubbles.reset();
          if (this.introSequence) {
            this.introSequence.introHints.hintReset();
            this.introSequence = null;
          }
          this.loader.show();
          this.ui.hideElement(document.querySelector("li.share"));
          this.ui.hideElement(document.querySelector("li.download"));
          document.querySelector("li.share").classList.remove("rubberBand");
          this.deactivateInteraction();
          this.colorizeBTN.classList.remove("deactivated");
          this.colorizeBTN.classList.add("hidden");
        } else {
          this.networkMessageBox.show();
          this.colorizeBTN.classList.remove("deactivated");
          this.colorizeBTN.classList.add("hidden");
        }
        break;
      case "share":
        const shareBTN = document.querySelector(".share");
        if (!shareBTN.classList.contains("deactivated"))
          this.shareImage(this.colorizedImage.b64_image);
        break;
      case "download":
        const downloadBTN = document.querySelector(".download");
        if (!downloadBTN.classList.contains("deactivated"))
          this.downloadImage(this.colorizedImage.b64_image);
        break;
      case "pen":
        this.IMAGE.state = "pen";
        document.getElementById("wrapper").classList.remove("open");
        document
          .querySelector(".drawing-content .button-wrapper")
          .classList.remove("open");
        document.getElementById("colorSource").classList.add("hide");
        this.hint.hide();
        break;
      case "magic":
        this.IMAGE.state = "magic";
        document.getElementById("wrapper").classList.remove("open");
        document
          .querySelector(".drawing-content .button-wrapper")
          .classList.remove("open");
        document.getElementById("colorSource").classList.add("hide");
        break;
      case "about":
        this.aboutBox.show();
        break;
      case "switch":
        //erase drawing if back to magic
        if (this.ui.switch.state) {
          // this.fullReset();
          this.bubbles.reset();
        } else {
          this.bubbles.reset();
        }
        // if (this.axl) {
        //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        //     action: "switch_change",
        //     label: this.ui.switch.state,
        //     value: 0,
        //     nonInteraction: false,
        //   });
        // }
        break;
    }
  }

  async onNewDataLoaded() {
    console.log("*** NewDataLoaded ***", this.playIntro);
    if (this.SHARED_IMAGE_ID) {
      const image = await Utils.loadImage(
        `${GLOBAL_PATH}serve/${this.SHARED_IMAGE_ID}`
      );
      console.log("TYPE OF IMAGE");
      if (typeof image == "object" && this.playIntro) {
        this.startIntro();
      } else {
        this.shareScreen.image = image;
        this.shareScreen.show();
        this.loader.hide();
        if (this.tracker) this.tracker.track("share_creen");
        // if (this.axl) {
        //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        //     action: "share_screen_open",
        //     nonInteraction: true,
        //   });
        // }
      }
    } else if (this.playIntro) {
      // START INTRO
      this.startIntro();
    } else {
      this.loader.hide();
      this.hint.moveTo(document.querySelector("li.magic"));
      this.hint.setHint("start_draw");
      this.hint.show();
      this.activateInteraction();
    }
  }

  startIntro() {
    // reset the size to make sure we are ready
    this.IMAGE.onResize();
    const dimensions = { width: this.IMAGE.width, height: this.IMAGE.height };
    this.colorizedImage.onResize(dimensions);
    // start the intro
    // this.ui.hideSwitch();
    this.SHARED_IMAGE_ID = null;
    this.playIntro = false;
    this.introSequence = new Intro(
      `${GLOBAL_PATH}json/intros/intro${Math.floor(Math.random() * 5)}.json`,
      this,
      this.translations,
      this.tracker
    );
    this.introSequence.addEventListener(
      "show_try_hint",
      this.handler.showTryHint
    );
    this.introSequence.addEventListener("skip", this.handler.skipIntro);
    this.INTRO_HAS_BEEN_INITIATED = true;
    this.introSequence.addEventListener("intro_ended", this.handler.introEnded);
    // if (this.axl) {
    //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "intro_started",
    //     nonInteraction: true,
    //   });
    // }
  }

  onAddedColor(data) {
    if (this.introSequence) {
      this.introSequence.introHints.hintReset();
      // this.introSequence = null;
    }

    // show color button if it was hidden
    if (this.colorizeBTN.classList.contains("hidden")) {
      this.colorizeBTN.classList.remove("hidden");
      this.hint.moveTo(this.colorizeBTN);
    }
    this.hint.countColorDot();
    //
    // record color stuff
    this.COLOR_RECORDER_FOR_INTRO.push(data);
    //
    // if (this.axl && !this.introSequence) {
    //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "color_added",
    //     label: data.color,
    //     value: 0,
    //     nonInteraction: false,
    //   });
    // }
  }

  onHasDrawnMagic() {
    if (this.introSequence) {
      this.introSequence.introHints.hintReset();
      // this.introSequence = null;
    }
    if (this.hint.state == "start_draw") {
      this.hint.hide();
      this.hint.addArrow();
      this.hint.setArrowLeft();
      this.hint.setHint("use_pen");
      this.hint.moveTo(document.querySelector("li.pen"));
    } else if (this.hint.state == "use_pen") {
      this.hint.countMagicStroke();
    }
    if (document.querySelector("li.pen").classList.contains("deactivated")) {
      document.querySelector("li.pen").classList.remove("deactivated");
    }

    //
    // if (this.axl && !this.introSequence) {
    //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "magic_line_added",
    //     value: 0,
    //     nonInteraction: false,
    //   });
    // }
  }
  onHasDrawnPen() {
    if (this.introSequence) {
      this.introSequence.introHints.hintReset();
      // this.introSequence = null;
    }
    if (this.hint.state == "use_pen") {
      this.hint.hide();
      this.hint.addArrow();
      this.hint.setArrowLeft();
      this.hint.setHint("add_color");
      this.hint.moveTo(document.querySelector("li.color"));
    } else if (this.hint.state == "add_color") {
      this.hint.countPenStroke();
    }
    //
    // if (this.axl && !this.introSequence) {
    //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "pen_line_added",
    //     value: 0,
    //     nonInteraction: false,
    //   });
    // }
  }

  openPanel() {
    if (!document.getElementById("wrapper").classList.contains("open")) {
      document.getElementById("wrapper").classList.add("open");
      document
        .querySelector(".drawing-content .button-wrapper")
        .classList.add("open");
      document.getElementById("colorSource").classList.remove("hide");
      // force color
      this.ui.force("color");
    }
  }
  closePanel() {
    if (document.getElementById("wrapper").classList.contains("open")) {
      document.getElementById("wrapper").classList.remove("open");
      document
        .querySelector(".drawing-content .button-wrapper")
        .classList.remove("open");
    }
  }

  delegateColorize(e) {
    e.preventDefault();
    this.transformImage();
    if (this.tracker) this.tracker.track("colorize");
  }

  transformImage(intro = false) {
    if (this.network.ONLINE) {
      // only if we are not in the tutorial!
      if (!this.introSequence) this.colorizeBTN.classList.add("deactivated");
      else this.colorizeBTN.classList.add("deactivated-but-visible");
      this.bubbles.unCancel();
      this.hint.hide();
      this.hint.setComplete();
      this.startTimer();
      this.colorizedImage.run();
      if (!this.colorizedImage.imageUpdatedAtLeastOnce) {
        const resizedImage = Utils.imageToDataUri(this.IMAGE.canvas, 512, 512);
        this.colorizedImage.directChangeTexture(resizedImage);
        if (Utils.isSmallOrMediumLayout()) this.showResultScreen();
      }
      if (Utils.isSmallOrMediumLayout()) this.showResultScreen();
      else this.openPanel();
      this.initColor();
      // force color UI
      if (!intro) this.ui.force("color");
      else this.openPanel();
    } else {
      this.networkMessageBox.show();
    }
  }

  showResultScreen() {
    // if we are on mobile,
    // hide the tools and drawing image
    // to show the result and bubbles only
    const isMobileOrMedium = Utils.isSmallOrMediumLayout();
    // also do it for the landscape layout
    const isLandscapeMobile = Utils.isLandscapeMobile();
    if (isMobileOrMedium || isLandscapeMobile) {
      this.closePanel();
      // hide toolbar and palette
      this.ui.hide();
      // collapse panel
      const wrapper = document.getElementById("wrapper");
      wrapper.classList.remove("open");
      document
        .querySelector(".drawing-content .button-wrapper")
        .classList.remove("open");
      // change layout to  show result on top
      document.getElementById("resultImage").classList.add("mobile-result");
      document.querySelector(".drawing-content").classList.add("mobile-result");
      document.getElementById("bubbles").classList.add("mobile-result");
      // display a "back to edit" button
      // Hide the 'colorize' button
      this.colorizeBTN.style.display = "none";
      this.endScreenButtonsContainer.style.display = "flex";
    }
  }

  backToEditScreen() {
    this.ui.hideResultScreenButtons();
    this.bubbles.cancel();
    this.bubbles.reset();
    if (this.introSequence) this.introSequence.introHints.setOpacity(0);
    this.bubbleLoader.hide();
    window.setTimeout(() => {
      this.ui.show();
      this.ui.showSwitch(true);
      //this.ui.showResultScreenButtons();
      const wrapper = document.getElementById("wrapper");
      if (
        this.colorizedImage.imageUpdatedAtLeastOnce &&
        this.ui.state == "color"
      )
        wrapper.classList.add("open");
      document
        .querySelector(".drawing-content .button-wrapper")
        .classList.add("open");
      if (this.ui.state == "color") this.ui.showPalette();
      document.getElementById("resultImage").classList.remove("mobile-result");
      const drawingContentContainer =
        document.querySelector(".drawing-content");
      drawingContentContainer.classList.remove("mobile-result");
      document.querySelector("#wrapper").style.transform = "none";
      document.getElementById("bubbles").classList.remove("mobile-result");
      this.colorizeBTN.style.display = "block";
      this.endScreenButtonsContainer.style.display = "none";
      document.body.style.overflow = "hidden";
    }, 1250);
    window.setTimeout(() => {
      document.querySelector("#wrapper").style.transform = "none";
    }, 600);
  }

  async bubbleClick(id) {
    // const data = {
    //   title: 'title',
    //   author: 'author',
    //   partner: 'partner',
    //   assetid: id,
    //   src: 'http://lh3.googleusercontent.com/yHw3UIrmPL4NiwnEzVEu9EvEk7JJ2bPZvk1eNDXywjs0C6nTVKRz9_oC_q-dryGW',
    // };
    this.assetInfoBox.show();
    Utils.fetchAssetInfo(id).then((data) => {
      this.assetInfoBox.populate(data);
    });

    if (this.tracker) this.tracker.track("asset_scren", id);

    // if (this.axl) {
    //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "open_asset_view",
    //     label: id,
    //     value: 0,
    //     nonInteraction: false,
    //   });
    // }

    // --> ANALYTICS
    // if (this.axl) {
    //   this.scope.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "navigate_to_asset",
    //     label: "asset_image / " + id,
    //     value: 0,
    //     nonInteraction: false,
    //   });
    // }
  }

  bubbleAppear(bubbleContainerHeight) {
    this.bubbleLoader.hide();
    if (!Utils.isSmallOrMediumLayout() && !Utils.isLandscapeMobile()) return;
    if (Utils.isLandscapeMobile()) {
      window.setTimeout(() => {
        this.ui.showResultScreenButtons();
      }, 500);
      return;
    }
    // calculate margin needed to offset the container
    const wrapper = document.querySelector("#wrapper");
    const ctaContainerHeight = 30;
    // here, get the actual size of the container!!!
    const headerHeight = 72;
    const bubbleHeight = bubbleContainerHeight; //  this.bubbles.container.clientHeight;
    const screenHeight = window.innerHeight + headerHeight / 2;
    const remainingScreenSpace = screenHeight - bubbleHeight;
    const newPositionY = remainingScreenSpace / 2;
    const oldPosition = wrapper.getBoundingClientRect();
    const oldPositionY = oldPosition.y + oldPosition.height / 2;
    const offset = oldPositionY - newPositionY + ctaContainerHeight;
    wrapper.style.transform = `translateY(-${offset}px)`;
    window.setTimeout(() => {
      this.ui.showResultScreenButtons();
    }, 500);
  }

  visitAsset(id) {
    this.axl.sendMessage(AxL.ChildToHost.NAVIGATE, "asset/" + id);
    if (this.tracker) this.tracker.track("navigate", id);
    //
    // if (this.axl) {
    //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "navigate_to_asset",
    //     label: id,
    //     value: 0,
    //     nonInteraction: false,
    //   });
    // }
  }

  visitLink(link) {
    this.axl.sendMessage(AxL.ChildToHost.NAVIGATE, link);
    //
    if (this.axl) {
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "navigate_to_asset",
        label: link,
        value: 0,
        nonInteraction: false,
      });
    }
  }

  shareImage(b64Image) {
    this.sharing.send(b64Image);
    // const shareData = {
    //   href: "#",
    //   title: "My manga creation",
    //   text: "Check it out on GAC!",
    //   files: [
    //     {
    //       data: b64Image.split(",")[1],
    //       name: "myMangaCreation.png",
    //       type: "image/png",
    //     },
    //   ],
    // };
    // this.axl.sendMessage(AxL.ChildToHost.SHARE, shareData);
    /*
     this.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {
            puzzleId: this.scope.UID,
            gallery: this.scope.customGallery,
          });
    */
  }

  async downloadImage(b64Image) {
    window.removeEventListener("resize", this.handler.resize);
    const date = new Date();
    const formattedDate =
      date.getFullYear() +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      ("0" + date.getDate()).slice(-2) +
      ("0" + date.getHours()).slice(-2) +
      ("0" + date.getMinutes()).slice(-2) +
      ("0" + date.getSeconds()).slice(-2);
    const waterMarkedImage = await Utils.addWaterMark(
      `${GLOBAL_PATH}images/logo.png`,
      b64Image,
      512,
      512
    );

    console.log(waterMarkedImage);
    Utils.save(waterMarkedImage, `giga_manga_${formattedDate}.png`);

    // if (this.tracker) this.tracker.track("download");
    // const a = document.createElement("a"); //Create <a>
    // // const date = new Date();
    // // const formattedDate =
    // //   date.getFullYear() +
    // //   ("0" + (date.getMonth() + 1)).slice(-2) +
    // //   ("0" + date.getDate()).slice(-2) +
    // //   ("0" + date.getHours()).slice(-2) +
    // //   ("0" + date.getMinutes()).slice(-2) +
    // //   ("0" + date.getSeconds()).slice(-2);
    // a.href = b64Image; //Image Base64 Goes here
    // a.download = `giga_manga_${formattedDate}.png`; //File name Here
    // a.style.display = "none";
    // document.body.appendChild(a);
    // a.click(); //Downloaded file
    // document.body.removeChild(a);
    // if (this.axl) {
    //   this.axl.sendMessage(AxL.ChildToHost.TRACK, {
    //     action: "download_b64_image",
    //     nonInteraction: false,
    //   });
    // }

    /**
     SET BACK THE RESIZE LISTENER FOR FUTUR SCREEN CHANGES
    */
    setTimeout(() => {
      window.addEventListener("resize", this.handler.resize);
    }, 1000);
  }

  reset() {
    this.IMAGE.onResize();
    const dimensions = { width: this.IMAGE.width, height: this.IMAGE.height };
    this.colorData.onResize(dimensions);
    this.colorizedImage.onResize(dimensions);
    if (this.introSequence) this.introSequence.onResize(dimensions);
    this.bubbles.reset();
    this.bubbleLoader.hide();
    this.hint.reset();
    this.hint.hide();
    this.hint.moveTo(document.querySelector("li.magic"));
    this.hint.setHint("start_draw");
    this.aboutBox.hide();
    this.colorizeBTN.classList.remove("deactivated");
    this.ui.hideElement(document.querySelector("li.share"));
    this.ui.hideElement(document.querySelector("li.download"));
    document.querySelector("li.share").classList.remove("rubberBand");
  }

  fullReset() {
    this.IMAGE.reset();
    this.IMAGE.resetDataAfterIntro();
    this.colorData.clear();
    this.colorizedImage.reset();
    this.bubbles.reset();
    this.hint.moveTo(document.querySelector("li.magic"));
    this.hint.setHint("start_draw");
    this.colorizeBTN.classList.add("hidden");
  }

  organizeUI() {
    // this.bubbles.reset();
    this.closePanel();
    this.backToEditScreen();
    this.ui.resetPalettePosition();
    console.log("STATE PLEASE", this.ui.switch.state);
    if (this.ui.switch.state) {
      console.log("FORCE MAGIC");
      this.ui.force("magic");
      this.introSequence = null;
      console.log("INTRO SEQUENCE IS NOW NULL");
    }
    this.ui.hideElement(document.querySelector("li.share"));
    this.ui.hideElement(document.querySelector("li.download"));
    document.querySelector("li.share").classList.remove("rubberBand");
  }

  // DEBUG FUNCTIONS
  startTimer() {
    this.start_time = new Date().getTime();
  }
  stopTimer() {
    const end_time = (new Date().getTime() - this.start_time) / 1000;
    console.log(":::: COLORIZATION TIMING ::::", end_time);
  }

  activateInteraction() {
    this.ui.container.classList.remove("deactivate");
    document.getElementById("wrapper").classList.remove("deactivate");
  }
  deactivateInteraction() {
    this.ui.container.classList.add("deactivate");
    document.getElementById("wrapper").classList.add("deactivate");
  }
}
